import * as angular from 'angular';

import { ComponentDefinition, LastProcessedDisplay, LastProcessedDisplayByGroup } from '../../models';

class ModelJobsTreeDetailsController implements angular.IComponentController {
    isLoading: boolean;
    lastProcessedDisplay: LastProcessedDisplay[];
    lastProcessedDisplayByGroup: LastProcessedDisplayByGroup;
    groups: any[];
    displayedGroups: any[];
    beginDate: string;
    endDate: string;

    static $inject = ['$scope', '$element'];

    constructor(
        private _$scope: angular.IScope,
        private _$element: angular.IAugmentedJQuery
    ) {
    }

    $onInit() {
        this._$scope.$watch(
            () => this.displayedGroups,
            () => this.scrollToTop()
        );
    }

    private scrollToTop() {
        this._$element.find('.model-container').scrollTop(0);
    }
}

export const wtModelJobsTreeDetails: ComponentDefinition = {
    componentId: 'wtModelJobsTreeDetails',
    controller: ModelJobsTreeDetailsController,
    template: require('./modelJobsTreeDetails.component.html'),
    controllerAs: 'vm',
    bindings: {
        lastProcessedDisplay: '<',
        lastProcessedDisplayByGroup: '<',
        isLoading: '<',
        groups: '<',
        beginDate: '<?',
        endDate: '<?'
    }
};